import {createApp} from 'vue';
import {createPinia} from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import App from './App.vue';
import DropdownMenu from 'v-dropdown-menu';
import {RecycleScroller} from "vue-virtual-scroller";
import PrimeVue from 'primevue/config';
import {definePreset} from "@primeuix/themes";
import Aura from '@primeuix/themes/aura';

import router from '@/routes/routerConfig';
import api from '@/api/api';

import './assets/style.css';
import 'primeflex/primeflex.min.css';
import 'primeicons/primeicons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import './assets/v-dropdown-menu.css';
import './assets/css/tour.css';
import {BlockUI, Button, Column, ConfirmationService, ConfirmDialog, DataTable, Dialog, Fieldset, InputText, MultiSelect, PickList, ProgressSpinner, Select, Tab, TabList, TabPanel, TabPanels, Tabs, Toast, ToastService} from "primevue";
import Tooltip from 'primevue/tooltip';

const app = createApp(App);

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#f4fafe',
            100: '#cae6fc',
            200: '#a0d2fa',
            300: '#75bef8',
            400: '#4baaf5',
            500: '#2196f3',
            600: '#1c80cf',
            700: '#1769aa',
            800: '#125386',
            900: '#0d3c61',
            950: '#0a2a47'
        },
        formField: {
            borderRadius: '3px',
            paddingX: '1rem'
        },
    }
});

app.use(PrimeVue, {
    ripple: true,
    theme: {
        preset: MyPreset
    },
    locale: {
        emptyMessage: 'Nenhum registro encontrado.'
    }
});

const pinia = createPinia();

pinia.use(piniaPluginPersistedstate);

app.use(DropdownMenu);
app.use(pinia);
app.use(router);
app.provide('axios', api);

app.component('RecycleScroller', RecycleScroller);
app.component('Tabs', Tabs);
app.component('TabList', TabList);
app.component('Tab', Tab);
app.component('TabPanels', TabPanels);
app.component('TabPanel', TabPanel);
app.component('MultiSelect', MultiSelect);
app.component('Select', Select);
app.component('InputText', InputText);
app.component('Button', Button);
app.component('Fieldset', Fieldset);
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('PickList', PickList);
app.component('ProgressSpinner', ProgressSpinner);
app.component('BlockUI', BlockUI);
app.component('Toast', Toast);
app.component('ConfirmDialog', ConfirmDialog);
app.component('Dialog', Dialog);

app.use(ToastService);
app.use(ConfirmationService);

app.directive('tooltip', Tooltip);

window.addEventListener("message", (ev) => {
    if (ev.data == "login-expirado") {
        router.push({name: "Login"})
    }
});

app.mount('#app');
